/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'
import { Link } from 'react-router'
import { defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
  games_back_to_games: {
    id: 'games.back_to_games',
    defaultMessage: 'Назад к списку игр',
  },
  all_slots: {
    id: 'games.all_slots',
    defaultMessage: 'Все слоты',
  },
})

export default function SlotsNav({ countryCode }) {
  return (
    <div className="slots__nav">
      <Link to="/games-vivo" className="slots--back" activeClassName="active">
        <BackIcon />
        <FormattedMessage {...messages.games_back_to_games} />
      </Link>
      {/* <Link to="/games/slots/" activeClassName="active">
        <FormattedMessage {...messages.all_slots} />
      </Link> */}
      <Link to="/games/slots/betsoft" activeClassName="active">
        Betsoft
      </Link>
      {/* {countryCode !== 'UZ' && (
        <Link to="/games/slots/betsolutions" activeClassName="active">
          Betsolutions
        </Link>
      )} */}
      <Link to="/games/slots/tom-horn" activeClassName="active">
        Tom Horn
      </Link>
    </div>
  )
}

export const BackIcon = ({ fill = '#000' }) => (
  <svg
    id="Layer"
    fill={fill}
    enableBackground="new 0 0 64 64"
    height="20"
    viewBox="0 0 64 64"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z" />
  </svg>
)



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/SlotsNav.jsx